import { render, staticRenderFns } from "./RolesPermissionEdit.vue?vue&type=template&id=773f85c2&"
import script from "./RolesPermissionEdit.vue?vue&type=script&lang=js&"
export * from "./RolesPermissionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports